module.exports = __webpack_public_path__ + "static/img/img-activity.58ec4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-activity.png
// module id = MkNy
// module chunks = 1